import { throwNull, throwUndefined } from '@esm-test/guards';
import { ObjectField } from './objectField.js';

/**
 * Represents a field extracted from a class instance.
 */
export class ClassInstanceField extends ObjectField {
  /** The parent class instance the field belongs to. */
  classInstance: object;

  /**
   * Initializes a new ClassInstanceField instance.
   * @param groupName - Parent group name.
   * @param name - Property/method name.
   * @param value - Property/method value.
   * @param classInstance - The parent instance.
   */
  constructor (groupName: string, name: string, value: any, classInstance: object) {
    super(groupName, name, value)

    throwUndefined("classInstance", classInstance);
    throwNull("classInstance", classInstance);

    this.classInstance = classInstance;
  }

}
